module.exports = __webpack_public_path__ + "img/slide-1.993cea8.jpg";